const wpcf7Elm = document.querySelector('.wpcf7');

wpcf7Elm?.addEventListener(
  'wpcf7submit',
  (event) => {
    if ([701].includes(event.detail.contactFormId)) {
      window.location = '/contact-us/thank-you/';
    }
  },
  false,
);
